import React from 'react';
import { motion } from 'framer-motion';
import HeroAnimation from '../components/HeroAnimation';
import { AiImageFrame } from '../components/AiImageBadge';

const Home: React.FC = () => {
  // Varianti per le animazioni
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1 } }
  };

  const slideUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.3 } }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section con animazione elegante 
      <HeroAnimation imagePath="/hero-image.jpg" />*/}
      <AiImageFrame position="bottom-right">
        <HeroAnimation imagePath="/villa_ristorante_tramonto.png" />
      </AiImageFrame>
      {/*<HeroAnimation imagePath="/Azienda-agricola.jpg" />
      {/* Introduzione */}
      <section className="py-20 bg-beige">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h2
              className="font-playfair text-3xl md:text-4xl text-verde-scuro mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              Benvenuti a Villa d'Arco
            </motion.h2>
            <motion.p
              className="font-montserrat text-lg text-verde-oliva mb-8 leading-relaxed"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Benvenuti a Villa d’Arco, un luogo dove l'eccellenza della cucina incontra la genuinità dei prodotti a chilometro zero.
              Nel cuore di Baronissi, tra colline verdi e profumi autentici, nasce un progetto che unisce la tradizione agricola alla passione per la buona cucina. 
              Un’azienda agricola e ristorante pensati per offrirvi un’esperienza unica, fatta di sapori genuini, accoglienza sincera e legame profondo con la terra. 
              Siete i benvenuti in un sogno che sta diventando realtà.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Sezione Ristorante */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="font-playfair text-3xl text-verde-scuro mb-6">Il Nostro Ristorante</h2>
              <p className="font-montserrat text-verde-oliva mb-6 leading-relaxed">
                Stiamo lavorando per aprire un ristorante dove valorizzeremo i prodotti locali e la cucina del territorio. 
                Tutti i piatti saranno preparati con ingredienti freschi e genuini, selezionati tra le eccellenze locali, 
                per farvi gustare i sapori autentici della nostra terra.
              </p>
              <a href="/ristorante" className="btn-primary inline-block">Scopri di più</a>
            </motion.div>
            <motion.div
              className="rounded-lg overflow-hidden shadow-xl"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <AiImageFrame>
                <img
                  src="/tavoli_giardino.jpg"
                  alt="Ristorante Villa d'Arco (immagine generata con intelligenza artificiale)"
                  className="w-full h-auto"
                  id="img_tavoli"
                />
              </AiImageFrame>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Sezione Azienda Agricola */}
      <section className="py-20 bg-crema">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              className="rounded-lg overflow-hidden shadow-xl order-2 md:order-1"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <AiImageFrame position="bottom-left">
                <img
                  src="/azienda-image.jpg"
                  alt="Azienda Agricola Villa d'Arco (immagine generata con intelligenza artificiale)"
                  className="w-full h-auto"
                />
              </AiImageFrame>
            </motion.div>
            <motion.div
              className="order-1 md:order-2"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <h2 className="font-playfair text-3xl text-verde-scuro mb-6">La Nostra Azienda Agricola</h2>
              <p className="font-montserrat text-verde-oliva mb-6 leading-relaxed">
                Coltiviamo con passione e dedizione prodotti di alta qualità, rispettando i ritmi della natura e
                le tradizioni agricole. Dai nostri terreni alla vostra tavola, garantiamo freschezza e genuinità
                in ogni prodotto, con particolare attenzione alla coltivazione dei funghi Cardoncelli.
              </p>
              <a href="/azienda-agricola" className="btn-primary inline-block">Scopri di più</a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Sezione Prodotti in Evidenza */}
      <section className="py-20 bg-white">
              <div className="container mx-auto px-4">
                <motion.h2
                  className="font-playfair text-3xl text-verde-scuro mb-12 text-center"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8 }}
                >
                  Le nostre coltivazioni principali
                </motion.h2>
      
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  {/* Funghi Cardoncelli */}
                  <motion.div
                    className="bg-beige rounded-lg overflow-hidden shadow-md"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                  >
                    <div className="h-64 overflow-hidden">
                      <AiImageFrame className="w-full h-full" compact>
                        <img
                          src="/prodotto-1.jpg"
                          alt="Funghi Cardoncelli (immagine generata con intelligenza artificiale)"
                          className="w-full h-full object-cover"
                        />
                      </AiImageFrame>
                    </div>
                    <div className="p-6">
                      <h3 className="font-playfair text-2xl text-verde-scuro mb-4">Funghi Cardoncelli</h3>
                      <p className="font-montserrat text-verde-oliva mb-4">
                        La nostra serra fungaia è dedicata alla coltivazione dei pregiati funghi Cardoncelli,
                        noti per il loro sapore delicato e la consistenza carnosa. Utilizziamo tecniche tradizionali
                        per garantire la massima qualità e genuinità.
                      </p>
                      <p className="font-montserrat text-verde-oliva">
                        I nostri funghi sono disponibili freschi tutto l'anno e sono l'ingrediente principale
                        di molti piatti del nostro ristorante.
                      </p>
                    </div>
                  </motion.div>
      
                  {/* Ortaggi */}
                  <motion.div
                    className="bg-beige rounded-lg overflow-hidden shadow-md"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <div className="h-64 overflow-hidden">
                      <AiImageFrame className="w-full h-full" compact>
                        <img
                          src="/prodotto-2.jpg"
                          alt="Ortaggi (immagine generata con intelligenza artificiale)"
                          className="w-full h-full object-cover"
                        />
                      </AiImageFrame>
                    </div>
                    <div className="p-6">
                      <h3 className="font-playfair text-2xl text-verde-scuro mb-4">Ortaggi di stagione</h3>
                      <p className="font-montserrat text-verde-oliva mb-4">
                        Nei nostri campi coltiviamo una vasta gamma di ortaggi di stagione, seguendo il ritmo
                        naturale delle stagioni. Pomodori, zucchine, peperoni, melanzane e molti altri prodotti
                        crescono nei nostri terreni senza l'uso di pesticidi chimici.
                      </p>
                      <p className="font-montserrat text-verde-oliva">
                        La freschezza e il sapore autentico dei nostri ortaggi sono il risultato di pratiche
                        agricole rispettose dell'ambiente e di una cura costante.
                      </p>
                    </div>
                  </motion.div>
      
                  {/* Olio di Aquara */}
                  <motion.div
                    className="bg-beige rounded-lg overflow-hidden shadow-md"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  >
                    <div className="h-64 overflow-hidden">
                      <AiImageFrame className="w-full h-full" compact>
                        <img
                          src="/olio_nostra-produzione.png"
                          alt="Olio di Aquara (immagine generata con intelligenza artificiale)"
                          className="w-full h-full object-cover"
                        />
                      </AiImageFrame>
                    </div>
                    <div className="p-6">
                      <h3 className="font-playfair text-2xl text-verde-scuro mb-4">Olio di Aquara</h3>
                      <p className="font-montserrat text-verde-oliva mb-4">
                        Il nostro olio extravergine di oliva nasce dalle colline di Aquara, 
                        dove il clima e il terreno donano alle olive un aroma intenso e armonioso. 
                        Raccogliamo e frangiamo le olive con metodi tradizionali, per preservare al meglio profumo, 
                        gusto e proprietà nutrizionali.
                      </p>
                      <p className="font-montserrat text-verde-oliva">
                        Dal colore dorato con riflessi verdi e dal sapore equilibrato, 
                        il nostro olio è ideale per esaltare ogni piatto, 
                        dalla cucina quotidiana alle ricette più raffinate del nostro ristorante.
                      </p>
                    </div>
                  </motion.div>
                </div>
              </div>
            </section>
      

      {/* Call to Action 
      <section className="py-20 bg-verde-oliva text-white">
        <div className="container mx-auto px-4 text-center">
          <motion.h2
            className="font-playfair text-3xl mb-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            Prenota un tavolo
          </motion.h2>
          <motion.p
            className="font-montserrat text-lg mb-8 max-w-2xl mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Vieni a scoprire i sapori autentici della nostra cucina e l'atmosfera accogliente del nostro ristorante.
          </motion.p>
          <motion.a
            href="/contatti"
            className="bg-oro text-verde-scuro font-montserrat font-semibold py-3 px-8 rounded-sm hover:bg-opacity-90 transition-all duration-300"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            Prenota ora
          </motion.a>
        </div>
      </section>*/}
    </div>
  );
};

export default Home;
